import React from 'react';
import { Card, ICON_LIST_BOX_OUTLINE } from '@doveit/bricks';
import { MissedCalls } from '../../../providers/api/dtos/applicant';
import { MAX_NO_ASWER_RETRY } from '../../containers/no-answer-action/NoAnswerAction';
import ApplicantMissedCallRegistryList from '../applicant-missed-call-registry-list/ApplicantMissedCallRegistryList';

export interface ApplicantMissedCallRegistryProps {
  missedCalls: MissedCalls,
  maxAttempts?: number,
}

const ApplicantMissedCallRegistry: React.FC<ApplicantMissedCallRegistryProps> = ({
  missedCalls,
  maxAttempts = MAX_NO_ASWER_RETRY,
}) => (
  <Card aria-label="Registro chiamate senza risposta">
    <Card.Header
      icon={{ path: ICON_LIST_BOX_OUTLINE }}
      title="Chiamate senza risposta"
    />
    <Card.Content>
      <ApplicantMissedCallRegistryList missedCalls={missedCalls} maxAttempts={maxAttempts} />
    </Card.Content>
  </Card>

);

export default ApplicantMissedCallRegistry;
